import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';

import ExecutiveDashboard from './ExecutiveDashboard';
import AgentIntelligence from './AgentIntelligence';
import ConversationIntelligence from './ConversationIntelligence';
import LeadPipelineIntelligence from './LeadPipelineIntelligence';
import SourceChannelPerformance from './SourceChannelPerformance';
import SiteVisitIntelligence from './SiteVisitIntelligence';

const ReportsV2Base = () => {
  return (
    <Box sx={{ flexGrow: 1, minHeight: '100vh', pt: 2, pb: 3, px: { xs: 2, sm: 3 } }}>
      <Routes>
        <Route path="/" element={<Navigate to="executive-dashboard" replace />} />
        <Route path="executive-dashboard" element={<ExecutiveDashboard />} />
        <Route path="agent-intelligence" element={<AgentIntelligence />} />
        <Route path="conversation-intelligence" element={<ConversationIntelligence />} />
        <Route path="lead-pipeline" element={<LeadPipelineIntelligence />} />
        <Route path="source-channel" element={<SourceChannelPerformance />} />
        <Route path="site-visit-intelligence" element={<SiteVisitIntelligence />} />
      </Routes>
    </Box>
  );
};

export default ReportsV2Base;
